<!--
BEDROCK Core
Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
-->

<!Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
-->

<!Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
-->

<template>
    <div class="sdev-nav-section-wrapper">

        <button @click="expanded = !expanded" class="sdev-nav-section-button" :class="{ 'is-active': isActiveSection }">
            <div class="sdev-nav-section-left">
                <span class="sdev-nav-icon">
                    <template v-if="section.icon">
                        <BaseIcon :name="section.icon" />
                    </template>
                    <template v-else>
                        {{ section.title?.charAt(0) }}
                    </template>
                </span>

                <span class="sdev-nav-label">
                    {{ section.title }}
                </span>
            </div>

            <div class="sdev-nav-section-right">
                <span v-if="hasSectionNotification(section)" class="sdev-nav-dot" />
                <span class="sdev-nav-chevron" :class="{ 'is-open': expanded }">
                    ⌄
                </span>
            </div>
        </button>

        <transition name="sdev-collapse">
            <div v-if="expanded" class="sdev-nav-children">
                <Item v-for="child in section.children" :key="child.key" :child="child" />
            </div>
        </transition>

    </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useNavigationUI } from '@/framework/bootstrap/useNavigationUI'
import Item from '@/framework/navigation/Item/Item.vue'

const props = defineProps({
    section: Object,
    collapsed: Boolean
})

const expanded = ref(false)
const route = useRoute()
const { hasSectionNotification } = useNavigationUI()

const isActiveSection = computed(() => {
    if (!props.section?.children) return false

    return props.section.children.some(child =>
        route.path.startsWith(child.path)
    )
})

watch(isActiveSection, (val) => {
    if (val) expanded.value = true
}, { immediate: true })
</script>